import React from 'react';
import { Meteor } from 'meteor/meteor';
import PropTypes from 'prop-types';
import { Button, Row, Col, Card } from 'react-bootstrap';
import { useStyles } from '../../../styles/mapStylesCustom';

import {
  isSharedPrivate,
  getId,
  getPublicPrivateId,
  isWithLocationPrivate
} from '../../../api/Maps/map-operations';

import ColBreak from '../../atoms/ColBreak';
import ShareIcon from '../../atoms/ShareIcon';

const MapSharePrivateComponent = ({
  map,
  toggleSharedPrivate,
  toggleWithLocationPrivate,
  location,
  isPublicMap
}) => {
  const classes = useStyles();
  const nameLocation = isWithLocationPrivate(map) ? 'with location' : '';

  const stringMap = isWithLocationPrivate(map)
    ? `/lng=${location.lng}&lat=${location.lat}&zoom=${location.zoom}`
    : '';
  return (
    <Row>
      {!isPublicMap && (
        <>
          <Col xs={6} sm={8} md={10}>
            <Button
              block
              onClick={() => {
                toggleSharedPrivate(getId(map), isSharedPrivate(map));
              }}
              className={isSharedPrivate(map) ? '' : classes.azulIpsilumButton}
              variant={isSharedPrivate(map) ? 'outline-success' : 'outline-info'}
            >
              {isSharedPrivate(map) ? 'Cerrar compartir mapa privado' : 'Compartir mapa privado'}
            </Button>
          </Col>
          <Col xs={6} sm={4} md={2} className="d-flex justify-content-center">
            <ShareIcon shared={isSharedPrivate(map)} />
          </Col>
          <ColBreak />
          <Col xs={6} sm={8} md={10}>
            <Button
              block
              onClick={() => {
                toggleSharedPrivate(getId(map), isSharedPrivate(map));
                toggleWithLocationPrivate(getId(map), isWithLocationPrivate(map));
              }}
              className={isSharedPrivate(map) ? '' : classes.azulIpsilumButton}
              variant={isSharedPrivate(map) ? 'outline-success' : 'outline-info'}
            >
              {isSharedPrivate(map)
                ? 'Cerrar compartir mapa privado con localización'
                : 'Compartir mapa privado con localización'}
            </Button>
          </Col>
        </>
      )}

      {(isSharedPrivate(map) || isPublicMap) && (
        <>
          <ColBreak />
          <Col xs={12}>
            <Card bg="light">
              <Card.Body>
                <Card.Subtitle className={classes.azulIpsilum}>
                  Shared Private Link {nameLocation}
                </Card.Subtitle>
                <Card.Link
                  href={`${Meteor.absoluteUrl(
                    `sharedPrivate/maps/${getPublicPrivateId(map)}${stringMap}`
                  )}`}
                  target="_blank"
                  className="text-break"
                  rel="noopener noreferrer"
                >
                  {`${Meteor.absoluteUrl(
                    `sharedPrivate/maps/${getPublicPrivateId(map)}${stringMap}`
                  )}`}
                </Card.Link>
              </Card.Body>
            </Card>
          </Col>
        </>
      )}
    </Row>
  );
};
MapSharePrivateComponent.defaultProps = {
  isPublicMap: false,
  location: {}
};

MapSharePrivateComponent.propTypes = {
  isPublicMap: PropTypes.bool,
  location: PropTypes.object,
  map: PropTypes.object.isRequired,
  toggleSharedPrivate: PropTypes.func.isRequired,
  toggleWithLocationPrivate: PropTypes.func.isRequired
};

export default MapSharePrivateComponent;
